// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"ceca2208","551":"2a37cce4","640":"244fb707","842":"8df647c5"}[chunkId] + ".chunk.js";
};